import { reviewApi } from './review.api';

export const reviewActions = {
  async getReviews({ commit }, payload) {
    try {
      commit('GET_REVIEWS_LOADING');
      const response = await reviewApi.getReviews(payload);
      commit('GET_REVIEWS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_REVIEWS_ERROR', error.response);
    }
  },
  async approveReview({ commit }, id) {
    try {
      commit('APPROVE_REVIEW_LOADING');

      const response = await reviewApi.approveReview(id);

      commit('APPROVE_REVIEW_SUCCESS', response.data);
    } catch (error) {
      commit('APPROVE_REVIEW_ERROR', error.response);
    }
  },
  async rejectReview({ commit }, id) {
    try {
      commit('REJECT_REVIEW_LOADING');

      const response = await reviewApi.rejectReview(id);

      commit('REJECT_REVIEW_SUCCESS', response.data);
    } catch (error) {
      commit('REJECT_REVIEW_ERROR', error.response);
    }
  },
};
